module.exports = __webpack_public_path__ + "img/PD1502194722977005568.6a14f4a0.png";